import { PhoneSettingsIcon } from './PhoneSettingsIcon';

/**
 * author: Google
 * id C9E81E97-C4DA-4612-AC4D-0F81C7986CD8
 * name phone-settings
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone-settings.svg
 * tags
 * - Settings 
 * - Cellphone / Phone 
 */
export const SettingsPhoneIcon = PhoneSettingsIcon;
export default SettingsPhoneIcon